import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Anchor from '../Anchor';
import IconClose from '../../assets/svgs/close.svg';

import SC from './styles';

import { noop } from '../../helpers';

class Modal extends Component {
  constructor(props) {
    super(props);
    // Set open state based on default props
    this.state = {
      open: props.open
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // If we have received an updated prop to open/close
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open });
    }
  }

  render() {
    const ModalLink = () => {
      return (
        <Anchor onClick={this.handleTextClick.bind(this)}>
          {this.props.text}
        </Anchor>
      );
    };

    return (
      <div className={this.props.className}>
        {this.props.text && <ModalLink />}
        <div>
          {this.state.open && (
            <SC.ModalWrapper>
              <SC.Overlay onClick={this.close.bind(this)} />
              <SC.ModalWindow>
                {!this.props.disableClose && (
                  <SC.CloseButton onClick={this.close.bind(this)}>
                    <IconClose />
                  </SC.CloseButton>
                )}
                {this.props.children}
              </SC.ModalWindow>
            </SC.ModalWrapper>
          )}
        </div>
      </div>
    );
  }

  handleTextClick() {
    this.setState({ open: true });
  }

  close(e) {
    e.preventDefault();
    if (!this.props.disableClose) {
      this.setState({ open: false });
      this.props.onClose(e);
    }
  }
}

Modal.defaultProps = {
  open: false,
  disableClose: false,
  onClose: noop
};

Modal.propTypes = {
  /** Extra class to apply to element */
  className: PropTypes.string,
  /** If modal is open by default */
  open: PropTypes.bool,
  /**
   * If set to true, modal does not show the close button.
   * And modal does not close if the user clicks on the backdrop.
   * */
  disableClose: PropTypes.bool,
  /** Handler when modal closes */
  onClose: PropTypes.func,
  /** If set, it will appear as Anchor text to open modal */
  text: PropTypes.string
};

export default Modal;
